import { FormControl, FormLabel, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

export default function WeekOfMonthField(props) {
    const { value, onChange } = props;
    const { t } = useTranslation();

    return (
        <Box>
            <FormLabel>{t('recurrence.field.weekOfMonth.label')}</FormLabel>
            <br/>
            <FormControl sx={{m: 1, minWidth: 150}}>
                <Select
                    value={value}
                    onChange={onChange}
                >
                    <MenuItem value={'1'}>{t('recurrence.ordinal.first')}</MenuItem>
                    <MenuItem value={'2'}>{t('recurrence.ordinal.second')}</MenuItem>
                    <MenuItem value={'3'}>{t('recurrence.ordinal.third')}</MenuItem>
                    <MenuItem value={'4'}>{t('recurrence.ordinal.fourth')}</MenuItem>
                    <MenuItem value={'50'}>{t('recurrence.field.weekOfMonth.lastOption')}</MenuItem>
                </Select>
            </FormControl>
        </Box>

    )
}
